/**
 * Validate input number
 * @param value
 * @param min
 * @param max
 * @returns {boolean}
 */
export function isInputNumberValid(value, min, max) {
  return !((value - min) * (value - max) <= 0);
}
